module.exports = __webpack_public_path__ + "static/media/bell-icon.e8c1781a.svg";